import EventBus from '@/services/eventBus/EventBus';
import Vue from 'vue';

export default class VueEventBus implements EventBus {
  private eventBus: Vue;
  constructor(eventBus: Vue) {
    this.eventBus = eventBus;
  }

  listen(eventName: string, handler: Function): void {
    this.eventBus.$on(eventName, handler);
  }
  
  listenOnce(eventName: string, handler: Function): void {
    this.eventBus.$once(eventName, handler);
  }
  
  remove(eventName: string, handler?: Function): void {
    if (handler) {
      this.eventBus.$off(eventName, handler);
    } else {
      this.eventBus.$off(eventName);
    }
  }
  
  removeAll(): void {
    this.eventBus.$off();
  }
  
  emit(eventName: string, payload: Object): void {
    this.eventBus.$emit(eventName, payload);
  }
};